"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _QuestionName = require("./QuestionName");

var _QuestionName2 = _interopRequireDefault(_QuestionName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["question", "unique", "value", "name"],

  components: {
    QuestionName: _QuestionName2.default
  },

  computed: {
    checkboxName: function checkboxName() {
      return this.name + "[]";
    }
  },

  data: function data() {
    return {
      selected: this.value ? this.value : []
    };
  },


  watch: {
    selected: function selected(value) {
      this.$emit("update", this.question.unique, value);
    }
  },

  methods: {
    getClassName: function getClassName(text) {
      return this.selected.includes(Fn.slugify(text)) ? "has-text-blue" : "has-text-black";
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/forms/elements/Checkbox.vue
// module id = mPrf
// module chunks = 0 1